import { createWidget } from '@alfa-bank/site-util-create-widget/create-widget';
import { VideoPlayer } from '@alfa-bank/site-video-player';
import { LayoutDesktop as Layout } from '@alfa-bank/site-layout/desktop';
import { Text } from '@alfa-bank/site-text-v2';

import type { TVideoBlockDesktop, IDepsDesktop } from '../models';
import { VideoBlock as Component } from '../layout/desktop';

import styles from './desktop.css';

export const VideoBlockDesktop = createWidget<IDepsDesktop, TVideoBlockDesktop>({
    styles,
    Layout,
    Text,
    VideoPlayer,
})(Component);
